var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "question-display",
      attrs: { id: "question-" + _vm.activeQuestion.TEST_QUESTION_RID }
    },
    [
      _c("div", { staticClass: "sr-only" }, [
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.questionNumber", {
                  number: _vm.activeQuestion.index + 1
                })
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pull-right" }, [
        _c("span", { staticClass: "pill pill-dark" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.pointsPossible", {
                  points: _vm.activeQuestion.TOTAL_POINTS
                })
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-type-instructions" }, [
        _c("strong", [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.activeQuestion.QUESTION_NAME) + "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "hint" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("MAIN_CONTENT.trueFalseQuestion.questionMessage")) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("h3", {
        staticClass: "question-text",
        domProps: { innerHTML: _vm._s(_vm.activeQuestion.QUESTION_TEXT) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "answers" },
        _vm._l(_vm.trueFalseDefaults, function(answer, index) {
          return _c(
            "div",
            {
              key: index,
              class: _vm.getAnswerClass(answer),
              attrs: { tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.answerTheQuestion(answer)
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.answerTheQuestion(answer)
                }
              }
            },
            [
              _c(
                "div",
                {
                  class: [
                    "answer-number",
                    { selected: _vm.answeredByStudent(answer) }
                  ]
                },
                [
                  _vm.answeredByStudent(answer)
                    ? _c("i", {
                        staticClass: "fa fas fa-arrow-circle-right",
                        attrs: {
                          "aria-label":
                            "Selected Answer " + _vm.answeredByStudent(answer),
                          "aria-live": "polite"
                        }
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(answer.ANSWER_NUMBER) + "\n\t\t\t\t"
                  ),
                  _vm.isGraded && _vm.answeredByStudent(answer)
                    ? _c(
                        "div",
                        {
                          staticClass: "answer-points",
                          attrs: { "aria-label": "Points Earned" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.testTaker.points", {
                                  points: _vm.pointsEarned
                                })
                              ) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "answer-text" }, [
                _vm._v("\n\t\t\t\t\t" + _vm._s(answer.ANSWER_TEXT) + "\n\t\t\t")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "grade-result" }, [
                _c("i", { class: _vm.getFeedbackIcon(answer) })
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("question-summary"),
      _vm._v(" "),
      _vm.testMode !== "grading"
        ? _c("test-buttons", { on: { "answer-save": _vm.submitAnswer } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }